<template>
	<el-row class="mainOnebox">
		<!-- 标题 -->
		<el-row class="mainOnebox_title">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>PRODUCT</el-breadcrumb-item>
				<el-breadcrumb-item>Tactile Paving</el-breadcrumb-item>
			</el-breadcrumb>
		</el-row>
		<!-- 内容 -->
		<el-row class="mainOnebox_main">
			<div class="mainOnebox_main_list_remove" v-for="(item,i) in imgdata" :key="i" @click="routelist(i)" @mouseenter="changeActive($event)" @mouseleave="removeActive($event)">
				<img :src="item.url">
				<span class="mainOnebox_main_list_name">{{item.title}}</span>
			</div>
			<div class="mainOnebox_main_list_none"></div>
			<div class="mainOnebox_main_list_none"></div>
		</el-row>
	</el-row>
</template>

<script>
	export default {
		components: {
			// banner:banner,
		},
		data() {
			return {
				imgdata: [
					{url: require('@/assets/image/productType/TactilePaving/HZ-P1008.jpg'),title: 'HZ-P1008',list1:'300*300*7mm',list2:'PU / ABS / Nylon / PVC',list3:'Dot',list4:'Frosting surface',list5:'Injection',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P1009.jpg'),title: 'HZ-P1009',list1:'300*300*7mm',list2:'PU / ABS / Nylon / PVC',list3:'Dot',list4:'Frosting surface',list5:'Injection',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P1010.jpg'),title: 'HZ-P1010',list1:'300*300*8.5mm',list2:'PU / ABS / Nylon / PVC',list3:'Dot',list4:'Frosting surface',list5:'Injection / Self-adhesive tape on back',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P1011.jpg'),title: 'HZ-P1011',list1:'600*300*7mm',list2:'Rubber',list3:'Dot',list4:'Frosting surface',list5:'Injection ',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P1012.jpg'),title: 'HZ-P1012',list1:'300*300*7mm',list2:'Rubber',list3:'Dot',list4:'Frosting surface',list5:'Injection ',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P1013.jpg'),title: 'HZ-P1013',list1:'300*300*7mm',list2:'PU / ABS / Nylon / PVC',list3:'Lines',list4:'Frosting surface',list5:'Injection ',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P1020.jpg'),title: 'HZ-P1020',list1:'300*300*7mm',list2:'PU / ABS / Nylon / PVC',list3:'Dots',list4:'Matte surface',list5:'Injection ',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P1291.png'),title: 'HZ-P1291',list1:'300*300*1.5mm',list2:'Aluminum / Stainless steel',list3:'Square opening',list4:'Hair-line finish',list5:'Stamping',list6:'Hezone Tile',list7:'For installation / Template',list8:'Null',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P1293.png'),title: 'HZ-P1293',list1:'300*300*1.5mm',list2:'Aluminum / Stainless steel',list3:'Small holes',list4:'Hair-line finish',list5:'Drilling',list6:'Hezone Tile',list7:'For installation / Template',list8:'Null',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P3172.png'),title: 'HZ-P3172',list1:'300*300*5mm',list2:'Stainless steel',list3:'Smooth dots',list4:'Hair-line finish',list5:'Press forming',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P6004.jpg'),title: 'HZ-P6004',list1:'300*300*7mm',list2:'Stainless steel',list3:'Rings pattern studs',list4:'Hair-line finish + Mirror finish',list5:'Weldding on plate',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P6005.jpg'),title: 'HZ-P6005',list1:'300*300*7mm',list2:'Stainless steel',list3:'Rings pattern studs',list4:'Mirror finish / high polish',list5:'Weldding on plate',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P6008.jpg'),title: 'HZ-P6008',list1:'300*300*5mm',list2:'Stainless steel',list3:'Rings pattern studs',list4:'Hair-line finish',list5:'Weldding on plate',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P6009.png'),title: 'HZ-P6009',list1:'300*300*7mm',list2:'Stainless steel',list3:'Smooth surface lines on top',list4:'Hair-line finish',list5:'Weldding on plate',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P6010.jpg'),title: 'HZ-P6010',list1:'300*300*7mm',list2:'Stainless steel',list3:'Diamond surface lines on top',list4:'Hair-line finish',list5:'Press forming',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P6011.jpg'),title: 'HZ-P6011',list1:'300*300*7mm',list2:'Stainless steel',list3:'Carborundum insert studs on top',list4:'Hair-line finish',list5:'Weldding',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
					{url: require('@/assets/image/productType/TactilePaving/HZ-P6012.jpg'),title: 'HZ-P6012',list1:'300*300*7mm',list2:'Stainless steel',list3:'Smooth surface lines on top',list4:'Hair-line finish',list5:'Press forming',list6:'Hezone Tile',list7:'Anti-skidding, The blind guide',list8:'R16',list9:'Direct Manufacturer',},
				],
				imgDatalis:4,//是从哪个分类进来的
			}
		},
		created() {
			this.setSessionData()
		},
		methods: {
			routelist(i) {
				this.$router.push({
					path: '/productList',
					query: {
						id: i,
						imgDataIndex:this.imgDatalis,//是从哪个分类进来的
					}
				})
			},
			changeActive(e) {
				e.currentTarget.className = 'mainOnebox_main_list';
			},
			removeActive(e) {
				e.currentTarget.className = 'mainOnebox_main_list_remove';
			},
			setSessionData(){
				sessionStorage.setItem('imgData'+this.imgDatalis,JSON.stringify(this.imgdata))
			}
		},

	}
</script>

<style lang="less" scoped>
	@vw: 19.2vw;

	.mainOnebox {
		background: url(~@/assets/image/home/home_bg1.jpg);

		.mainOnebox_title {
			width: 100%;
			padding-left: 7vw;
			margin: 0 auto;
			title-align: center;
			margin-top: 80/@vw;
			margin-bottom: 50/@vw;

			/deep/.el-breadcrumb {
				font-size: 24/@vw;
			}
		}

		.mainOnebox_main {
			max-width: 1530px;
			margin: 0 auto;
			height: auto;
			padding-bottom: 100/@vw;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: row;
			flex-wrap: wrap;

			.mainOnebox_main_list {
				width: 350px;
				height: 350px;
				margin: 1vh 1.5vw;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 350px;
					height: 350px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					position: absolute;
					bottom: 0;
					height: 100%;
					width: 100%;
					font-weight: 700;
					color: #fafafa;
					width: 100%;
					z-index: 999;
					left: 0;
					display: flex;
					align-items: center;
					justify-content: center;
					background-color: #000000;
					background-color: rgba(51, 51, 51, 0.5);
					font-size: 20px;
					transition: all 0.5s ease 0s;
					cursor: pointer;
				}
			}
			.mainOnebox_main_list_remove {
				width: 350px;
				height: 350px;
				margin: 1vh 1.5vw;
				position: relative;
				overflow: hidden;
				cursor: pointer;

				img {
					width: 350px;
					height: 350px;
					position: relative;
				}

				.mainOnebox_main_list_name {
					display: none;
				}
			}
			.mainOnebox_main_list_none {
				width: 350px;
				margin: 1vh 1.5vw;
				height: 0px;
			}
		}
	}
</style>
